import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";

function Featuring() {
  return (
    <MKBox component="section" pt={3} pb={8}>
      <Container>
        
        <Grid container justifyContent="center" sx={{ textAlign: "center" }}>
          <Grid item xs={12} md={3}>
            <DefaultCounterCard
              count={150}
              separator=","
              title="Research Projects"
              description="Ongoing and completed projects across various disciplines"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultCounterCard
              count={50}
              separator=","
              suffix="+"
              title="Partner Institutions"
              description="Collaborating with universities and research centers worldwide"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultCounterCard
              count={1000}
              separator=","
              suffix="+"
              title="Publications"
              description="Peer-reviewed articles, books, and conference papers"
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Featuring;
